module.exports = __webpack_public_path__ + "assets/img/tab1_04.e5f64255.jpg";